const Payments = {
  AcceptPaymentsAtBank: "Payments.AcceptPaymentsAtBank",
  UnhandledBankPaymentsHeader: "Payments.UnhandledBankPaymentsHeader",
  UnhandledBankPaymentsSubHeader: "Payments.UnhandledBankPaymentsSubHeader",
  IncomingInvoiceShortName: "Payments.IncomingInvoiceShortName",
  Payments: "Payments.Payments",
  NumReceipts: "Payments.NumReceipts",
  NumPayments: "Payments.NumPayments",
  IncomingInvoicePaymentFiles: "Payments.IncomingInvoicePaymentFiles",
  IncomingInvoiceManualPayments: "Payments.IncomingInvoiceManualPayments",
  ReceiptPaymentFile: "Payments.ReceiptPaymentFile",
  SalaryPayouts: "Payments.SalaryPayouts",
  ManualPayouts: "Payments.ManualPayouts",
  PaymentsMarkedAsApproved: "Payments.PaymentsMarkedAsApproved",
  PaymentFile: "Payments.PaymentFile",
  PaymentsNeedToApprove: "Payments.PaymentsNeedToApprove",
  MarkedAsApproved: "Payments.MarkedAsApproved",
  BankIdPaymentsHeader: "Payments.BankIdPaymentsHeader",
  BankIdPaymentsSubHeader: "Payments.BankIdPaymentsSubHeader",
  BankIdMarkedPayments: "Payments.BankIdMarkedPayments",
  PaymentsTooltipMessage: "Payments.PaymentsTooltipMessage",
  PaymentsSignedSuccessMessage: "Payments.PaymentsSignedSuccessMessage",
  BankIdSignTimeout: "Payments.BankIdSignTimeout",
  BankIdSignError: "Payments.BankIdSignError",
  StoppedPaymentRescheduleSuccess: "Payments.StoppedPaymentRescheduleSuccess",
  PaymentsNeedToSign: "Payments.PaymentsNeedToSign",
  StoppedPayments: "Payments.StoppedPayments",
  NumberOfPayments: "Payments.NumberOfPayments",
  PaymentStopped: "Payments.PaymentStopped",
  StoppedSelectionPanelHeader: "Payments.StoppedSelectionPanelHeader",
  StoppedSelectionPanelDescription: "Payments.StoppedSelectionPanelDescription",
  StoppedSelectionPanelDescription2: "Payments.StoppedSelectionPanelDescription2",
  MarkedPayments: "Payments.MarkedPayments",
  NewPayoutDate: "Payments.NewPayoutDate",
  OnlyWorkingDays: "Payments.OnlyWorkingDays",
  PausedPayments: "Payments.PausedPayments",
  PausedPaymentsResumeSuccess: "Payments.PausedPaymentsResumeSuccess",
  PausedSelectionPanelHeader: "Payments.PausedSelectionPanelHeader",
  PausedSelectionPanelDescription: "Payments.PausedSelectionPanelDescription",
  ManualPayment: "Payments.ManualPayment",
  Pay: "Payments.Pay",
  PaymentsCount: "Payments.PaymentsCount",
  PausedPaymentsHeader: "Payments.PausedPaymentsHeader",
  PausedPaymentsMarked: "Payments.PausedPaymentsMarked",
  }
export default Payments;